import NavBar from '../Components/NavBar'
import { site } from '../variables'
import React, { Fragment, useState, useEffect } from 'react'
import { useHistory,  useLocation } from 'react-router-dom'
import useStyles from '../Styles/useStyles'
import { Container, TableContainer, Table, Paper, TableHead, TableBody, TableRow, TableCell, Button } from '@material-ui/core'
import {IntlProvider, FormattedNumber} from 'react-intl'

const Boletos = () => {  
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();

  const [fromTab, setFromTab] = useState(0);
  const [boletos, setBoletos] = useState([]);

  useEffect(() => {
    if (sessionStorage.getItem('pathname') !== '/lista_boletos') {
      history.push('/');
      return;
    }
    if (location.state.data) {
      setFromTab(location.state.tab)
      setBoletos(location.state.data)
    }
    else {
      history.push('/')
    }
  }, [])

  const openBoletoSite = (data, objeto) => {
    sessionStorage.setItem('pathname', '/boleto')
    let encode = btoa(data);
    history.push({'pathname': '/boleto', search: '?data=' + encode, state: {'objeto': objeto}})
  }

  const openBoletoLink = (data) => {
    let encode = btoa(data);
    window.open(site + '/boleto?data=' + encode );
  }

  const handleClick = () => {
    openBoletoSite(location.state.nota + 'J' + boletos[0].cnpjCPF, boletos)
  }

  const renderBtnTodos = () => {
    return(
      <Fragment>
        <div style={{width: '100%', display:'flex', flexDirection:'row', justifyContent: 'flex-end',}}>
            <Button type="button" fullWidth className={classes.verTodos} onClick={handleClick} >Ver Todos</Button>
        </div>
      </Fragment>
    )
  }

  const renderTable = () => {
    return(
        <Fragment>
        <TableContainer component={Paper} className={classes.tableContainer}>
        <Table>
          <TableHead>
            <TableRow className={classes.headRow}>
              <TableCell className={classes.headCell} align="center">Nota</TableCell>
              <TableCell className={classes.headCell} align="center">Vencimento</TableCell>
              <TableCell className={classes.headCell} align="center">Valor</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {boletos.map((boleto) => (
                <TableRow key={boleto.id} className={classes.tableRow} 
                onClick={() => {
                  sessionStorage.setItem('pathname', '/boleto')
                  openBoletoSite(boleto.cnpjCPF + 'N' + boleto.numeroDocumento, boleto)
                }}>
                <TableCell className={classes.tableCell} align="center">{boleto.numeroDocumento}</TableCell>
                <TableCell className={classes.tableCell} align="center">
                {boleto.dataVencimento.substr(8, 2) + '/' + boleto.dataVencimento.substr(5, 2) + '/' + boleto.dataVencimento.substr(0, 4)}</TableCell>
                <TableCell className={classes.tableCell} align="center">
                <IntlProvider locale="pt" defaultLocale="br">
                  <FormattedNumber value={boleto.valorDaDuplicata} style="currency" currency="BRL"/>
                </IntlProvider>
                </TableCell>
              </TableRow>
              ))
            }
          </TableBody>
        </Table>
        </TableContainer>
        </Fragment>

      )
    

  }
  return(
    <Fragment>
      <NavBar/>
      <Container maxWidth="md">
      {fromTab === 0 ? renderBtnTodos() : null}
      {renderTable()}
      </Container>
    </Fragment>
  )
}

export default Boletos